/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './SpringPages.css';

const PATHWAYS = [
  {
    label: "Founders Pathway",
    title: "build something new",
    text: "Turn an idea into a business of your own. If you don't have an idea yet, that's a normal place to start. The early stages are there to help you find one.",
    bold: "The Founders Pathway is built for growing a business beyond yourself.",
    phases: [
      ["Find Your Path", "Explore your ideas, find the one worth building, and see who it could be for."],
      ["Make It Real", "Lay the foundations for your business: the right structure, the legal and financial set-up, and a clear plan for how it will run."],
      ["Build, Fund & Grow", "Bring your product or service to life, explore whether you'll need funding, and find the people you need around you to support and advise you."],
      ["Scale With Confidence", "Put the people, systems and finances in place so your business can grow beyond you."],
    ],
  },
  {
    label: "Employment Pathway",
    title: "stretch back into the workforce",
    text: "Step back into employment with a clearer view of your strengths and what you're looking for. SPRING can help you go back stronger, more confident and ready for what's next.",
    bold: "The Employment Pathway is built for finding the right role and planning your next step.",
    phases: [
      ["Know Your Strengths", "Get clear on your skills, experience and interests, and what you bring."],
      ["Find Your Direction", "Explore which roles fit you now, what matters most in your next one, and whether any new learning would help."],
      ["Get Job Ready", "Rebuild your CV for both the person reading it and the AI screening tools, then get ready to show yourself at your best in interviews."],
      ["Go After It", "Look for the right openings and put yourself forward, with mentor support if and when you need it."],
    ],
  },
  {
    label: "Independent Pathway",
    title: "go it alone, on purpose",
    text: "Turn what you already know into your own consultancy or sole trader business. Your own skills and experience are where it starts, and SPRING can guide you along the way.",
    bold: "The Independent Pathway is to build something of your own with the skills you already have.",
    phases: [
      ["Find Your Expertise", "Pin down what you know that people value, and who it could help most."],
      ["Build Your Foundation", "Set up the important systems, building blocks and administrative processes to work for yourself."],
      ["Win Your First Clients", "Shape your offer, start building your client list, and plan how you'll approach and onboard clients."],
      ["Grow On Your Terms", "Work out what you want this to look like, and how big you want it to be."],
    ],
  },
];

export default function PathwaysPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const fromReport = location.state?.fromReport || false;

  return (
    <div className="spring-page" data-testid="pathways-page">
      <div className="spring-page-inner" style={{ paddingTop: 32 }}>
        <span className="spring-label">Pathways</span>
        <h1 className="spring-headline">three pathways. it's a staged journey.</h1>

        <p className="pathway-lead">Three pathways. Three different destinations. The same staged journey to get there.</p>
        <p className="pathway-body-muted">Four phases, taken in order, each one broken into stages you work through at your own pace. You always know where you are, what you are doing next, and why it matters.</p>

        <p className="pathway-lead" style={{ marginTop: 32 }} data-testid="pathways-above-cards">You don't have to do it on your own. You can take this one step at a time, at your own pace.</p>

        {/* Three pathway columns */}
        <div className="pathways-columns" data-testid="pathway-columns">
          {PATHWAYS.map((pw, idx) => (
            <div key={idx} className="pathway-column" data-testid={`pathway-col-${idx}`}>
              <div className="pathway-header-card">
                <span className="pathway-label">{pw.label}</span>
                <h3 className="pathway-title">{pw.title}</h3>
                <p className="pathway-desc">{pw.text}</p>
                <p className="pathway-desc" style={{ marginTop: 12 }} data-testid={`pathway-bold-${idx}`}><strong style={{ color: '#FFFFFF' }}>{pw.bold}</strong></p>
              </div>
              <div className="pathway-phases">
                {pw.phases.map(([name, desc], pi) => (
                  <div key={pi} className="pathway-phase-strip" style={{ alignItems: 'flex-start' }} data-testid={`pathway-${idx}-stage-${pi + 1}`}>
                    <span className="pathway-phase-num">{String(pi + 1).padStart(2, '0')}</span>
                    <span>
                      <span className="pathway-phase-name" style={{ display: 'block' }}>{name}</span>
                      <span className="pathway-phase-desc">{desc}</span>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="pathway-lead" data-testid="pathways-closing-line">You'll have human mentors and AI support beside you all the way.</p>

        {fromReport && (
          <button onClick={() => navigate(-1)} className="pathway-back-link" data-testid="back-to-report-link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
            Back to my report
          </button>
        )}
      </div>
    </div>
  );
}
